<bread-crumb></bread-crumb>

<h2 class="v_center">
    <button mat-icon-button [routerLink] = "['/dashboard/zimbrainstance']" class="f_left">
        <mat-icon>arrow_back</mat-icon>
    </button>
    {{ 'zimbrainstance.manage' | translate }} 
</h2>


<mat-card class="card ">
  <mat-card-content class="card-content">
   <form #f = "ngForm">
   
        <div fxLayout="row" >

            <mat-form-field fxFlex = "20">
                <mat-label translate> zimbrainstance.code </mat-label>
                <input  matInput  type="text" required placeholder="" [(ngModel)]="zimbrainstance.code" name="code" 
                    maxlength   =   "10"
                    pattern     =   "[a-zA-Z0_9]*"
                >
                <mat-hint class="form_note" translate> zimbrainstance.code_note </mat-hint>
            </mat-form-field>
  
            <mat-form-field fxFlex = "28" fxFlexOffset="2">
                <mat-label translate> zimbrainstance.name </mat-label>
                <input  matInput  type="text" required placeholder="" [(ngModel)]="zimbrainstance.name" name="name">
            </mat-form-field>

        </div>

        <div fxLayout="row" >

            <mat-form-field fxFlex = "30">
                <mat-label translate> zimbrainstance.url </mat-label>
                <input  matInput  type="text" required placeholder="" [(ngModel)]="zimbrainstance.url" name="url" >
            </mat-form-field>

            <mat-form-field fxFlex = "30" fxFlexOffset="2">
                <mat-label translate> zimbrainstance.domain </mat-label>
                <input  matInput  type="text" required placeholder="" [(ngModel)]="zimbrainstance.domain_name" name="domain_name" >
                <mat-hint class="form_note">{{ 'zimbrainstance.domain_note' | translate }}</mat-hint>
            </mat-form-field>

        </div>

        <!-- <div fxLayout="row" >

            <mat-form-field fxFlex = "30">
                <mat-label translate> zimbrainstance.auth_token </mat-label>
                <input  matInput  type="text" placeholder="" [(ngModel)]="zimbrainstance.auth_token" name="auth_token" >
            </mat-form-field>

            <div fxFlex="18" fxFlexOffset="2">
                <mat-checkbox [(ngModel)]="zimbrainstance.update_auth_token" name="update_auth_token"> 
                    {{ 'zimbrainstance.update_token' | translate }}
                </mat-checkbox>
                <br />
                <mat-hint translate class="form_note"> zimbrainstance.update_token_note </mat-hint>
            </div>

        </div> -->
        
    </form>
    <div fxLayout="row">
          <mat-card-actions class="card-actions width-field-100 t_right">
                <button mat-raised-button color="primary" (click)="save()" [disabled]="f.invalid"> 
                    <mat-icon>save</mat-icon>
                    {{ 'generic.submit' | translate }} 
                </button>
          </mat-card-actions>
    </div>

   </mat-card-content>
</mat-card>
